import { STATUSPAGE } from '@repo/ui';
import { GetAllPersonOverviewIndicatorsUseCaseInterface } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useCallback, useState } from 'react';

export const usePersonOverviewTab = () => {
  // states
  const [loadingIndicators, setLoadingIndicators] = useState<boolean>(false);

  const [indicators, setIndicators] =
    useState<GetAllPersonOverviewIndicatorsUseCaseInterface.Result>(null);

  const [requestStatus, setRequestStatus] = useState<STATUSPAGE>(
    STATUSPAGE.INITIAL,
  );

  // hooks
  const { personService } = useService();

  const requestGetAllPersonOverviewIndicators = useCallback(
    async (params: GetAllPersonOverviewIndicatorsUseCaseInterface.Params) => {
      setLoadingIndicators(true);
      setRequestStatus(STATUSPAGE.LOADING);

      try {
        const res = await personService.getAllPersonOverviewIndicators(params);
        setIndicators(res);
        setRequestStatus(STATUSPAGE.DONE);
      } catch (err) {
        console.log(err);
        setIndicators(null);
        setRequestStatus(STATUSPAGE.ERROR);
        notifyError(err.message || 'Erro ao buscar indicadores');
      } finally {
        setLoadingIndicators(false);
      }
    },
    [],
  );

  return {
    indicators,
    requestStatus,
    loadingIndicators,
    requestGetAllPersonOverviewIndicators,
  };
};
